// utils/financeCalculations.js
export const calculateFinanceTotals = (contract, selectedUnits, selectedBuilding, dateMetrics) => {
  const rent = parseFloat(contract.rent) || 0;
  const serviceCharge = parseFloat(contract.serviceCharge) || 0;
  const deposit = parseFloat(contract.deposit) || 0;
  const ejariFee = parseFloat(contract.ejariFee) || 0;
  const commissionFee = parseFloat(contract.commissionFee) || 0;
  const parkingFee = parseFloat(contract.parkingFee) || 0;
  const discount = parseFloat(contract.discount) || 0;
  const otherFee = parseFloat(contract.otherFee) || 0;
  const preSettled = parseFloat(contract.preSettled) || 0;
const currentUserfromLocal= localStorage.getItem("currentUser")
const vatPfromLocal= currentUserfromLocal
console.log("vatPfromLocal:",vatPfromLocal)

  const isResidential = (contract.tenancyType || '').trim().toUpperCase() === 'RESIDENTIAL';
  const buildingVatPercent = parseFloat(selectedBuilding?.VATPercentage);
  // const vatPercent = isResidential ? 0 : (isNaN(buildingVatPercent) ? 5 : buildingVatPercent);
  const vatPercent = isResidential ? 0 : (isNaN(buildingVatPercent) ? 5 : buildingVatPercent);
  const serviceVatPercent = isResidential ? 0 : vatPercent;

  const totalRent = selectedUnits.reduce((sum, unit) => sum + (Number(unit.MonthlyRent) || 0), 0);
  const totalService = selectedUnits.reduce((sum, unit) => sum + (Number(unit.ServiceCharge) || 0), 0);

  const rentVat = rent > 0 ? ((rent - discount) * vatPercent) / 100 : 0;
  const serviceVat = serviceCharge > 0 ? ((serviceCharge - discount) * serviceVatPercent) / 100 : 0;
  const commissionVat = commissionFee > 0 ? ((commissionFee - discount) * vatPercent) / 100 : 0;
  const parkingFeeVat = parkingFee > 0 ? ((parkingFee - discount) * vatPercent) / 100 : 0;
  const ejariVat = ejariFee > 0 ? (ejariFee * vatPercent) / 100 : 0;

  const grossTotal = rent + serviceCharge + ejariFee + commissionFee + parkingFee + otherFee;
  const totalIncome = grossTotal - discount;
  const netIncome = totalIncome - preSettled;

  return {
    rent,
    serviceCharge,
    deposit,
    ejariFee,
    ejariVat,
    commissionFee,
    parkingFee,
    parkingFeeVat ,
    discount,
    otherFee,
    preSettled,
    totalRent,
    totalService,
    vatPercent,
    serviceVatPercent,
    vatAmt: rentVat,
    serviceVatAmt: serviceVat,
    commissionVatAmt: commissionVat,
    grossTotal,
    totalIncome,
    netIncome,
    netRent: rent + rentVat,
    netService: serviceCharge + serviceVat,
    netCommission: commissionFee + commissionVat,
    totalAllocation: rent + serviceCharge + ejariFee + commissionFee + parkingFee,
    totalUnits: selectedUnits.length
  };
};


// {
//   //"commissionFee": 60,
//   //"commissionVatAmount": 3,
//   //"deposit": 300,
//   //"discount": 50,
//   //"ejariFee": 200,
//   //"grossTotal": 5490,
//   //"netCommission": 63,
//   //"netIncome": 5400,
//   //"netRent": 4725,
//   //"netService": 241.5,
//   //"otherFee": 100,
//   //"parkingFee": 400,
//   //"preSettled": 40,
//   //"rentAmount": 4500,
//   //"rentForPeriod": 4500,
//   //"serviceCharge": 230,
//   //"serviceVatAmount": 11.5,
//   //"serviceVatPercent": 5,
//   //"totalAllocation": 5390,
//   //"totalIncome": 5440,
//   //"totalRent": 4500,
//   //"totalServiceCharge": 230,
//   //"totalUnitsCC": 1,
//   //"vatAmount": 225,
//   //"vatPercent": 5
// }

